import { render, staticRenderFns } from "./Sreportable.vue?vue&type=template&id=b6783582&scoped=true"
import script from "./Sreportable.vue?vue&type=script&lang=js"
export * from "./Sreportable.vue?vue&type=script&lang=js"
import style0 from "./Sreportable.vue?vue&type=style&index=0&id=b6783582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6783582",
  null
  
)

export default component.exports